module.exports = __webpack_public_path__ + "static/media/ff4.5364be9a.jpg";